import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import ChangeImpactFormContainer from '../../../containers/projects/ChangeImpactFormContainer.jsx';

const NewChangeImpact = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Change Impact | ChangeSync</title>
    </Helmet>
    <ChangeImpactFormContainer projectId={projectId} slug={slug} />
  </>
);

NewChangeImpact.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewChangeImpact));
